module.exports = __webpack_public_path__ + "img/c5.43c3ac33.png";